import ExportWordEvidencePdfRequestDTO from 'models/dto/Reports/ExportWordEvidencePdfRequestDTO';
import ReportRequestDTO, { ReportStorageBehavior } from 'models/dto/Reports/ReportRequestDTO';
import AppError from 'utils/appError';
import { toBlob } from 'utils/string';
import http, { getFileNameFromResponse } from './httpService';

export const apiGetReport = async (
  reportRequest: ReportRequestDTO,
  accessToken: string,
): Promise<Blob | string | undefined> => {
  try {
    if (!reportRequest.reportDefinition) throw new AppError('reportRequest.report is undefined');

    const ar = await http.post<string>(
      `/reports/${reportRequest.reportDefinition.id}`,
      reportRequest,
      http.getRequestConfig(accessToken),
    );
    if (!ar || !ar.data || ar.data.length === 0) return undefined;

    if (reportRequest.storageBehavior === ReportStorageBehavior.SharePoint) {
      return ar.data;
    } else {
      return toBlob(ar.data);
    }
  } catch (err) {
    throw AppError.fromApiError(err);
  }
};

export const apiCheckSharePointReportWriteAccess = async (accessToken: string): Promise<string | undefined> => {
  try {
    const ar = await http.get<string>(`/reports/haswriteaccess`, http.getRequestConfig(accessToken));

    return ar.data;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
};

export const apiExportWordEvidencePdf = async (
  request: ExportWordEvidencePdfRequestDTO,
  accessToken: string,
): Promise<File> => {
  try {
    const config = {
      ...http.getRequestConfig(accessToken),
      responseType: 'blob' as const,
    };

    const ar = await http.post<Blob>(`/reports/export/word/pdf`, request, config);
    if (!ar.data || ar.data.size === 0) {
      throw new AppError('Word evidence PDF response contains no data');
    }

    const fileName = getFileNameFromResponse(ar);

    const contentType = ar.data.type || 'application/pdf';

    return new File([ar.data], fileName, { type: contentType });
  } catch (err) {
    throw await AppError.fromBlobApiError(err);
  }
};
